import { render, staticRenderFns } from "./assetListChooser.vue?vue&type=template&id=0ed60c75&"
import script from "./assetListChooser.vue?vue&type=script&lang=js&"
export * from "./assetListChooser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports